'use client'

import withClientComponent from 'core/components/withClientComponent'
import { useEffect, useState } from 'react'
import QRCode from 'qrcode'
import { useParams } from 'next/navigation'
import Image from 'next/image'

type TDownloadQRCodeProps = {
  className?: string
}
const DownloadQRCode = (props: TDownloadQRCodeProps) => {
  // 下载QrCode
  const [downloadUrl, setDownloadUrl] = useState<string>('')
  const { lang } = useParams()
  const createDownloadQRcode = () => {
    const address = `${window.location.origin}/${lang}/app/downLoad`
    QRCode.toDataURL(document.createElement('canvas'), address, { width: 74, height: 74, margin: 1 }).then((res) => {
      setDownloadUrl(res)
    })
  }
  useEffect(() => {
    createDownloadQRcode()
  }, [])

  if (!downloadUrl) return null
  return <Image className={props.className} src={downloadUrl} alt="scan QR code" width={74} height={74} />
}

export default withClientComponent(DownloadQRCode)
